import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const City = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  const { fulfillmentPlanId } = fulfillment;

  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) || {};

  const { salesOrdersFulfilledIds } = fulfillmentPlan;

  const [salesOrderId] = salesOrdersFulfilledIds ?? [];

  const [shipTo] =
    useSelector((state) =>
      Global.selectEntitiesSalesOrderProperty(state, {
        salesOrderId,
        property: 'shipTos',
      }),
    ) ?? [];

  return shipTo?.city ?? '';
};

City.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const city = {
  getMessageDescriptor: () => messages.city,
  name: <FormattedMessage {...messages.city} />,
  id: 'city',
  render: (data) => <City fulfillmentId={data.id} />,
};
